import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api/client';
import { useAuth } from '../../hooks/useAuth';

export function AcceptTerms() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleAccept() {
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/accept-terms');
      await refresh();
      navigate('/events');
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#F8F9FF] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8">
        <h2 className="text-2xl font-serif font-bold text-indigo-700 mb-2">Our Terms of Use have been updated</h2>
        <p className="text-stone-500 text-sm mb-6">
          EventsCarousel has zero tolerance for objectionable content or abusive behavior. Please review our{' '}
          <a href="/terms" className="text-indigo-600 hover:underline">Terms of Use</a>
          {' '}and{' '}
          <a href="/privacy" className="text-indigo-600 hover:underline">Privacy Policy</a>
          {' '}before continuing.
        </p>

        {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

        <button
          onClick={handleAccept} disabled={loading}
          className="w-full bg-indigo-600 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-indigo-700 disabled:opacity-50 transition-colors"
        >
          {loading ? 'Continuing…' : 'I Agree, Continue'}
        </button>
      </div>
    </div>
  );
}
